import { PartnerFormStyle } from "@xapp/stentor-form-widget-channel";

/**
 * CostGuide's approved form look, as a named style bundle.
 *
 * ONE definition, exported so every consumer reads the same values: the code
 * fallback in contact-app's partner registry, and the Storybook story that shows
 * the look. Duplicating it drifts -- the story and the registry had already
 * diverged on the button colours, which is how a CostGuide-preset form ended up
 * rendering a stock magenta Continue button inside a teal frame.
 *
 * Once `public.partnerBranding.formStyle` ships (XappMedia/stentor-api#5753) the
 * API-served bundle wins and this is only reached when that fetch fails.
 *
 * Colour notes, all from the approved design:
 *  - #1aacbe is the frame border, the buttons and the selected chip/date state.
 *  - #22a2b4 is the tab -- deliberately a DIFFERENT teal from the border.
 *  - #eef8fa is the card interior the framed step sits on.
 */
export const COST_GUIDE_FORM_STYLE: PartnerFormStyle = {
    enabled: true,
    theme: {
        // The frame: 4px of this colour.
        borderColor: "#1aacbe",
        // The approved design's inputs and buttons are slightly squarer than stock.
        // The frame's own card is square regardless of this -- see FormFrame.
        borderRadius: "8px",
        backgroundColor: "#eef8fa",
        headerBackgroundColor: "#22a2b4",
        headerTextColor: "#ffffff",
        // The form's own controls. Without these the widget keeps its stock palette
        // and the Next button renders orange inside a teal frame.
        primaryButtonColor: "#1aacbe",
        primaryButtonTextColor: "#ffffff",
        // Also teal: a step that sets nextLabel routes to the SECONDARY button, whose
        // stock colour is magenta.
        secondaryButtonColor: "#1aacbe",
        secondaryButtonTextColor: "#ffffff",
        text: {
            color: "#1c3f47",
        },
        chips: {
            // Both states. Only the selected pair was set, so an UNSELECTED chip fell through to
            // the customer's own theme -- on book.xapp.ai that rendered American Dream's maroon
            // pills inside an otherwise entirely teal form. A chip spends most of its life
            // unselected, so it was the resting state that looked wrong.
            //
            // Same class as the stock magenta Continue button this file's header records: a
            // themable surface the preset does not claim is a surface the customer keeps.
            backgroundColor: "#d6eef2",
            color: "#1c3f47",
            backgroundColorSelected: "#1aacbe",
            colorSelected: "#ffffff",
        },
        date: {
            backgroundColorSelected: "#1aacbe",
        },
        font: {
            fontFamily: "Montserrat, Arial, Verdana, sans-serif",
            link: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&family=Poppins:wght@400;700&display=swap",
        },
        standAlone: {
            backgroundColor: "rgb(243, 248, 251)",
        },
        externalWidget: {
            // Their booking embed is tall; without this the page jumps as it mounts.
            minHeight: "600px",
        },
    },
    framing: {
        tabLabel: "BOOK YOUR ESTIMATE",
        introPlacement: "above-tab",
    },
};
